import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import OktaAuth from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'
import { createPinia } from 'pinia'

const oktaAuth = new OktaAuth({
    issuer: process.env.VUE_APP_OKTA_ISSUER,
    clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
    redirectUri: process.env.VUE_APP_CLIENT_HOST + '/login/callback',
    scopes: ['openid']
})

createApp(App).use(createPinia())
  .use(router)
  .use(OktaVue, { oktaAuth })
  .mount('#app');
